import { Alert, Button, Form, Input } from "antd";
import LockIcon from "../../assets/icons/LockIcon";
import AuthLayout from "../../layouts/AuthLayout";

export default function ResetPassword() {
  return (
    <AuthLayout>
      <Alert
        message={
          <span>
            A code has been sent to your email Address <b>name@email.com</b>,
            Use the code here
          </span>
        }
        className="mb-4 text-[#046A37] bg-[#D7FFEB] border-[#8FE7B8]"
      />

      <Form name="reset-password" layout="vertical">
        <Form.Item
          name="code"
          rules={[{ required: true, message: "Please enter the code!" }]}
        >
          <Input placeholder="Enter code" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          rules={[{ required: true, message: "Please enter a new password!" }]}
        >
          <Input.Password prefix={<LockIcon />} placeholder="New password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm your password!" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match!"));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockIcon />}
            placeholder="Confirmed new password"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className="" block>
            Reset Password
          </Button>
        </Form.Item>
      </Form>
    </AuthLayout>
  );
}
